export default __webpack_public_path__ + "static/media/login-bg.895a9a08.svg";